export default __webpack_public_path__ + "static/media/placeholder-4.2c6001e7.png";